import React from 'react';
import { Box, SelectChangeEvent } from '@mui/material';
import { NewTypeAhead } from '../../../../presentation';
import { Option } from '@converge/graphql';

export interface AssigneeDropdownProps {
  taskId: string;
  options: { value: string | null | undefined; label: string }[];
  onChange?: (taskId: string, value: string) => void;
  hideBorders?: boolean;
  disabled?: boolean;
  isNotActive?: boolean;
  onUpdateTaskOwner: (
    event: SelectChangeEvent<unknown>,
    taskUuid: string
  ) => void | Promise<void>;
}

export const AssigneeDropdown = ({
  taskId,
  options,
  onChange,
  disabled,
  isNotActive,
  onUpdateTaskOwner,
}: AssigneeDropdownProps) => {
  const handleChangeOption = React.useCallback(
    (selectedOption: Option | null) => {
      const newValue = selectedOption ? (selectedOption.value as string) : null;

      // Create a synthetic event for the API handler
      const syntheticEvent = {
        target: { value: newValue },
      } as SelectChangeEvent<unknown>;

      // Call the API handler - the form state is already handled by NewFromSelectField's Controller
      onUpdateTaskOwner(syntheticEvent, taskId);
    },
    [taskId, onUpdateTaskOwner]
  );

  return (
    <Box className="assignee-dropdown-wrapper" sx={{ marginRight: '10px' }}>
      <NewTypeAhead
        name={`assignee-${taskId}`}
        className="task-owner"
        options={options}
        hideLabel
        hideBorders={false}
        onChangeOption={handleChangeOption}
        disabled={disabled}
        placeholder="Select Claim Handler"
      />
    </Box>
  );
};

export default AssigneeDropdown;
